// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"c376e040","239":"43a26727","455":"fa98e5ba","806":"95c1db93","977":"9981d8ed"}[chunkId] + ".chunk.js";
};